<div class="custella-modal">
    <form>
         <div class="custella-modal-header align-items-center">
            <div class="custella-modal-header-text">Create {{data === 'asset' ? 'an Asset' : 'a Work Order'}}</div>
            <i class="pi pi-times" [pTooltip]="translate?.general?.buttons?.close.singular" tooltipPosition="left" (click)="modalRef.hide()"></i>
        </div>

        <div class="custella-form-container position-relative d-block w-100 rounded-2 m-0 pt-3">
             <form [formGroup]="addAssetJoForm">
                <div class="custella-form-container-content m-0">
                    <!-- FOR ASSETS -->
                     <ng-container *ngIf="data == 'asset'">
                        <div class="custella-content-row pe-0">
                            <div class="custella-content-row-input col-6">
                                <span class="custella-content-row-input-title mandatory">{{ translate?.asset.fields.name.singular }}</span>
                                <input pInputText autocomplete="off" type="text" maxlength="255" formControlName="name" name="name" />
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['name'].touched && addAssetJoForm.controls['name'].invalid">
                                    <span *ngIf="addAssetJoForm.controls['name'].errors?.required">{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                            <div class="custella-content-row-input col-6">
                                <span class="custella-content-row-input-title mandatory">{{ translate?.asset.fields.status.singular }}</span>
                                <p-dropdown [options]="statuses" [filter]="true" optionLabel="name" optionValue="id" name="status" formControlName="status" [placeholder]="translate?.general.messages.none"></p-dropdown>
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['status'].touched && addAssetJoForm.controls['status'].invalid">
                                    <span *ngIf="addAssetJoForm.controls['status'].errors?.required">{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="custella-content-row align-items-baseline pe-0">
                            <div class="custella-content-row-input col-6">
                                <div class="d-flex align-items-baseline justify-content-between gap-2">                   
                                    <span class="custella-content-row-input-title mandatory">{{ translate?.asset.fields.serialNo.singular }}
                                        <i class="fa-regular fa-circle-info fa-xs" [pTooltip]="translate?.asset.tooltips.serialNo.singular" tooltipPosition="right"></i>
                                    </span>
                                    <p-button [label]="translate?.general.buttons.generateTemporarySerialNo.singular" styleClass="h-25" (onClick)="generateTemporarySerialNo()"></p-button>

                                </div> 
                                <input pInputText autocomplete="off" type="text" maxlength="40" formControlName="serialNo" name="serialNo"/>
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['serialNo'].touched && addAssetJoForm.controls['serialNo'].invalid ">
                                    <span *ngIf="addAssetJoForm.controls['serialNo'].errors?.required" id="label_AssetSerialNoReqField" >{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                            <div class="custella-content-row-input col-6">
                                <span class="custella-content-row-input-title mandatory">{{ translate?.asset.fields.type.singular }}</span>
                                <p-dropdown [options]="types" optionLabel="name" optionValue="id" name="type" formControlName="type" [filter]="true" [placeholder]="translate?.general.messages.none"></p-dropdown>
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['type'].touched && addAssetJoForm.controls['type'].invalid">
                                    <span *ngIf="addAssetJoForm.controls['type'].errors?.required" id="label_AssetTypeReqField" >{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="data == 'jo'">
                        <!-- FOR JOB ORDER -->
                        <div class="custella-content-row pe-0">
                            <div class="custella-content-row-input col-6">
                                <span class="custella-content-row-input-title mandatory">{{translate?.jobOrder.fields.name.singular}}</span>
                                <input type="text" pInputText autocomplete="off" formControlName="orderName" name="orderName"/>
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['name'].touched && addAssetJoForm.controls['name'].invalid">
                                    <span *ngIf="addAssetJoForm.controls['name'].errors?.required">{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                            <div class="custella-content-row-input col-6">
                                <span class="custella-content-row-input-title mandatory" id="label_JobStatus" >{{translate?.jobOrder.fields.status.singular}}</span>
                                <p-dropdown
                                    [placeholder]="translate?.general.messages.none"
                                    [showClear]="true"
                                    optionLabel="fieldLabel"
                                    optionValue="name"
                                    formControlName="joStatus"
                                    [options]="jobOrderStatuses"
                                    name="status"
                                ></p-dropdown>
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['status'].touched && addAssetJoForm.controls['status'].invalid">
                                    <span *ngIf="addAssetJoForm.controls['status'].errors?.required">{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="custella-content-row pe-0">
                            <div class="custella-content-row-input col-6">
                                <span class="custella-content-row-input-title mandatory">{{translate?.jobOrder.fields.orderType.singular}}</span>
                                <p-dropdown
                                    optionLabel="name"
                                    [placeholder]="translate?.general.messages.none"
                                    [showClear]="true"
                                    [options]="jobOrderTypes"
                                    optionLabel="name"
                                    optionValue="id"
                                    formControlName="joType"
                                    name="joType"                                
                                ></p-dropdown>
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['joType'].touched && addAssetJoForm.controls['joType'].invalid">
                                    <span *ngIf="addAssetJoForm.controls['joType'].errors?.required">{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                            <div class="custella-content-row-input col-6">
                                <span class="custella-content-row-input-title mandatory">{{translate?.jobOrder.fields.orderTimeDate.singular}}</span>
                                <p-calendar
                                    dateFormat="dd/mm/yy"
                                    yearRange="2000:2030"
                                    
                                    selectionMode="single"
                                    [placeholder]="translate?.general.messages.none"
                                    formControlName="installationDate"
                                    name="installationDate"
                                    appendTo="body"
                                    [showTime]="true"
                                    hourFormat="12"
                                    [yearNavigator]="true"></p-calendar>
                                <div class="p-error text-10" *ngIf="addAssetJoForm.controls['installationDate'].touched && addAssetJoForm.controls['installationDate'].invalid">
                                    <span *ngIf="addAssetJoForm.controls['installationDate'].errors?.required">{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
             </form>

             <!-- Container Footer -->
            <div class="custella-form-container-footer flex-end mb-0">
                <div class="flex-align-center justify-content-end">
                    <button class="custella-btn-white text-12 ms-2" (click)="modalRef.hide()">{{translate?.general?.buttons?.cancel.singular}}</button>
                    <p-button *ngIf="data === 'asset'" [label]="translate?.general?.buttons?.save.singular" styleClass="ms-2 h-32" (onClick)="goToNextStep()"></p-button> <!--  /* From Import Asset */ -->
                    <p-button *ngIf="data === 'jo'" [label]="translate?.general?.buttons?.save.singular" styleClass="ms-2 h-32" (onClick)="goToLearnMore()"></p-button> <!--  /* From Import Work Order */ -->
                </div>
            </div>
        </div>

    </form>
</div>